import React from 'react';
import styles from './Pill.module.scss';

const Pill = ({ label, variant }) => {
  return (
    <div
      className={styles['pill']}
      style={{
        color: variant,
        backgroundColor: `${variant}10`,
        border: `1px solid ${variant}`,
      }}
    >
      {label}
    </div>
  );
};

export default Pill;
